import React from 'react';
import ContentLoader from 'react-content-loader';
import { fakeSettings } from '@/constants/constants';
import styles from './styles';

const DefaultFake = () => {
  return (
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-sm-12">
          <ContentLoader height="100vh" width="100%" viewBox="50 50 100% 100vh"  {...fakeSettings}>
            {/* <rect x="0" y="15" rx="4" ry="4" width="100vw" height="100" /> */}
            <rect x="0" y="120" rx="2" ry="2" width="100vw" height="80vh" />
          </ContentLoader>
          </div>
        </div>
      <style jsx>{styles}</style>
    </div>
  );
}


export default DefaultFake;
